import { EventParams } from '../Analytics.types';
import { InstancesStore } from '../context';

export const logEventName = (eventName: string, devEnvironment: boolean) => {
  if (devEnvironment) {
    console.log('AnalyticsEvent: ' + eventName);
  }
};

export const handleEventSending = (
  instances: InstancesStore,
  devEnvironment: boolean,
  eventName: string,
  eventParams?: EventParams
): void => {
  const specifiedInstance = eventParams?.options?.sendTo;

  if (specifiedInstance) {
    if (Array.isArray(specifiedInstance)) {
      specifiedInstance.forEach(instance => {
        const currentInstance = instances[instance];

        if (currentInstance?.instance) {
          logEventName(eventName, devEnvironment);
          currentInstance.instance['logEvent'](eventName, eventParams);
        }
      });
      return;
    }

    const currentSpecifiedInstance = instances[specifiedInstance];

    if (!currentSpecifiedInstance?.instance)
      throw new Error(`${specifiedInstance} instance is not available`);

    logEventName(eventName, devEnvironment);

    return currentSpecifiedInstance.instance['logEvent'](
      eventName,
      eventParams
    );
  }

  for (let instanceName in instances) {
    if (instances[instanceName]?.instance) {
      logEventName(eventName, devEnvironment);
      instances[instanceName].instance['logEvent'](eventName, eventParams);
    }
  }
};
